const DIGITS = '0123456789'
const HEX_CHARACTERS = '0123456789abcdef'

const randomCharacter = characters =>
  characters.charAt(Math.floor(Math.random() * characters.length))

/**
 * Generate an eight-character schedule id:
 * one decimal digit followed by seven lowercase hexadecimal characters.
 */
export const getRandomScheduleId = () => {
  let id = randomCharacter(DIGITS)
  for (let index = 0; index < 7; index += 1) {
    id += randomCharacter(HEX_CHARACTERS)
  }
  return id
}
